import { Assert } from "@seriously-rad/seriouslyrad-framework-core/Assert";
import { DataSource } from "@seriously-rad/seriouslyrad-framework-core/Data/DataSource";
import { AndExpression } from "@seriously-rad/seriouslyrad-framework-core/Expressions/AndExpression";
import { ComparisonExpression } from "@seriously-rad/seriouslyrad-framework-core/Expressions/ComparisonExpression";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { ButtonStyleEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ButtonStyleEnum";
import { IParameterDialog, ParameterDialog, ParameterDialogPropertyValues } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ParameterDialog";
import { PropertyEditorComboBoxApplicationEntity } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/PropertyEditorComboBoxApplicationEntity";
import { NAMESPACE } from "./_Namespace";

export type IntegratedDataSetRecordLogEntryFilterParameterDialogPropertyValues =
    ParameterDialogPropertyValues
    & {
    };

export type IntegratedDataSetRecordLogEntryFilterParameterDialogProperties = {
    [name in keyof IntegratedDataSetRecordLogEntryFilterParameterDialogPropertyValues]: Property<IntegratedDataSetRecordLogEntryFilterParameterDialogPropertyValues[name]>
};

export interface IIntegratedDataSetRecordLogEntryFilterParameterDialog extends IParameterDialog, IntegratedDataSetRecordLogEntryFilterParameterDialogProperties
{
}

export class IntegratedDataSetRecordLogEntryFilterParameterDialog extends ParameterDialog implements IIntegratedDataSetRecordLogEntryFilterParameterDialog
{
    // #region Static

    public static override classNamespace = NAMESPACE + "IntegratedDataSetRecordLogEntryFilterParameterDialog";
    public static override className = "IntegratedDataSetRecordLogEntryFilterParameterDialog";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<IntegratedDataSetRecordLogEntryFilterParameterDialogPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                buttonStyle: ButtonStyleEnum.okCancel,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    protected propertyEditorDataSet?: PropertyEditorComboBoxApplicationEntity;
    protected propertyEditorStatus?: PropertyEditorComboBoxApplicationEntity;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<IntegratedDataSetRecordLogEntryFilterParameterDialogPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _createElement()
    {
        const
            $$element = super._createElement();

        this.propertyEditorDataSet =
            new PropertyEditorComboBoxApplicationEntity({
                editMode: true,
                primaryEntity: "IntegratedDataSets",
                primaryEntityDescriptionProperty: "name",
                propertyDisplayName: "Data Set"
            })
                .appendTo(this);

        this.propertyEditorStatus =
            new PropertyEditorComboBoxApplicationEntity({
                editMode: true,
                primaryEntity: "LookupItems",
                primaryEntityDescriptionProperty: "description",
                primaryEntityFilter: "id eq 5f816563-ffe9-4bc5-968e-873dc42fbd7a or id eq 1aff0244-777d-4a4a-829a-ab4837762ed2",
                propertyDisplayName: "Status"
            })
                .appendTo(this);

        return $$element;
    }
    public override createExpression()
    {
        Assert.isNotNullOrUndefined(this.propertyEditorDataSet, "this.propertyEditorDataSet");
        Assert.isNotNullOrUndefined(this.propertyEditorStatus, "this.propertyEditorStatus");

        const
            expression = new AndExpression(),
            dataSet = this.propertyEditorDataSet.value.get(),
            status = this.propertyEditorStatus.value.get();

        if (dataSet)
            expression.add(new ComparisonExpression({ path: "integratedDataSetRecord.integratedDataSetId", value: dataSet }));

        if (status)
            expression.add(new ComparisonExpression({ path: "statusLookupItemId", value: status }));

        return expression.count() > 0 ? expression : null;
    }
    public override openAsync()
    {
        Assert.isNotNullOrUndefined(this.propertyEditorDataSet, "this.propertyEditorDataSet");
        Assert.isNotNullOrUndefined(this.propertyEditorStatus, "this.propertyEditorStatus");

        const
            dataSource = new DataSource({ data: {} });

        this.propertyEditorDataSet.dataSource.set(dataSource);
        this.propertyEditorStatus.dataSource.set(dataSource);

        return super.openAsync();
    }

    // #endregion

    // #endregion
}

